__turbopack_context__.v({
  "className": "manrope_8001c38c-module__H6IIjq__className",
  "variable": "manrope_8001c38c-module__H6IIjq__variable",
});
